import styled from "styled-components/macro";

export const FetalSexResultBlockWrapper = styled.div`
  display: grid;
  gap: 1.25rem;
  grid-template-rows: auto minmax(7rem, auto);
  isolation: isolate;
  min-height: 14rem;
  overflow: hidden;
  padding: 0.75rem 0 1.5rem;
  position: relative;
  width: 100%;
`;

export const FetalSexResultConfettiLayer = styled.div`
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  z-index: 0;

  canvas {
    height: 100% !important;
    inset: 0;
    position: absolute !important;
    width: 100% !important;
  }
`;

export const FetalSexResultLeadIn = styled.div`
  justify-self: start;
  padding: 0 1.5rem;
  position: relative;
  z-index: 1;
`;

export const FetalSexResultGrid = styled.div<{
  $isTwin: boolean;
}>`
  align-items: center;
  display: grid;
  gap: 1rem;
  grid-template-columns: ${({ $isTwin }) =>
    $isTwin ? "repeat(auto-fit, minmax(9rem, 1fr))" : "auto"};
  justify-content: center;
  justify-self: center;
  max-width: ${({ $isTwin }) => ($isTwin ? "32rem" : "100%")};
  min-height: 7rem;
  position: relative;
  width: 100%;
  z-index: 1;
`;

export const FetalSexResultRow = styled.div<{
  $extend?: boolean;
}>`
  align-items: center;
  display: grid;
  gap: 1.25rem;
  grid-template-columns:
    62px
    ${({ $extend }) => ($extend ? "minmax(7rem, 14rem)" : "4rem")};
  justify-content: center;
  min-width: 0;

  svg {
    display: block;
    height: 62px;
    justify-self: center;
    width: 62px;
  }
`;
